import styled from 'styled-components';

export const LargeText = styled.div`
  font-size: 48px;
  line-height: 48px;
  font-weight: 600;
  color: var(--p-color-categorical-1);
`;
